<!-- 港区数据对比 -->
<template>
  <el-dialog
    width="80%"
    :visible.sync="visible"
    :before-close="cancel"
    :close-on-click-modal="false"
    :title="$t('SeaExport.DataComparison')"
  >
    <div class="harbour-data-compare">
      <div class="harbour-compare-tit">
        <span>{{ $t('Message.Explain') }}</span>
        <span>{{ $t('Message.compareHarbourTips1') }}</span>
        <span style="display: block; margin-left: 37px;">{{ $t('Message.compareHarbourTips2') }}</span>
        <span style="display: block; margin-left: 37px;">{{ $t('Message.compareHarbourTips3') }}</span>
        <span style="margin-left: 37px;">4.</span>
        <span style="color:orange;">{{ $t('Message.compareHarbourTips4') }}</span>
      </div>
      <cargo-left-right-resize
        :left-style="{flex:'none','max-width':'190px'}"
        :right-style="{'overflow': 'hidden'}"
        style="min-height:100%"
      >
        <template slot="left">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="harbour.gridOptions"
            :row-data="harbour.rowData"
            :column-defs="harbour.columnDefs"
            style="min-width: 160px;width:100%;height:100%;"
            @gridReady="params=>{harbour.gridApi=params.api}"
          />
        </template>
        <template slot="right">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="detail.gridOptions"
            :row-data="detail.rowData"
            :column-defs="detail.columnDefs"
            style="min-width: 160px;width:100%;height:100%;"
            @gridReady="params=>{detail.gridApi=params.api}"
          />
        </template>
      </cargo-left-right-resize>
    </div>
    <div slot="footer">
      <el-button type="primary" no="1" @click="submitHarbour">{{ $t('Message.UpdatedData') }}</el-button>
      <el-button no="2" @click="cancel">{{ $t('Message.Cancel2') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import lodash from 'lodash'
import StrUtils from '@/utils/StrUtils'
import { deepClone } from '@/utils'
import { PortDataCompareUtils } from '@/class/cargo/model/utils/PortDataCompareUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'

export default {
  name: 'NewCompareHarbourDialog',
  components: { CargoLeftRightResize },
  props: {
    visible: { type: Boolean, default: () => false },
    job: { type: Object, default: () => {}, require: true },
    harbourSource: { type: Array, default: () => [], require: true }, // 港区数据
    dataSource: { type: Array, default: () => [], require: true },
    hqFlag: { type: Boolean, default: () => true },
    hcFlag: { type: Boolean, default: () => true },
    containerHeightFlag: { type: Boolean, default: () => true },
    hQHCFlag: { type: Boolean, default: () => false }
  },
  data() {
    return {
      usageMap: {},
      tableList: [],
      selection: [],
      addNewGoods: [],
      showExpand: [],
      containerUsages: [],
      poItems: [],
      changeUsage: {}, // 需要变更的箱货号map
      newUsages: [], // 新增的箱货信息
      localHbrBourKeys: {},
      selectionContainerNo: '',
      selectKeys: [],
      allMap: {},
      delUsageKeys: [],
      harbour: {
        rowData: [],
        gridApi: null,
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowClicked: this.onRowClicked
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.ContainerNo'),
            colId: 'containerNo',
            field: 'containerNo',
            width: 155,
            flex: 1
          }
        ]
      },
      selectionKeys: [],
      detail: {
        rowData: [],
        gridApi: null,
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true,
          suppressRowTransform: true,
          context: {
            componentParent: this
          },
          onRowSelected: event => {
            const data = event.data
            if (this.selectKeys.indexOf(data.uuid) === -1) {
              this.selectKeys.push(data.uuid)
            }
          },
          onSelectionChanged: event => {
            // 获取所有行数据
            const allRowData = event.api.getModel().rowsToDisplay.map(row => row.data)
            // 获取已勾选行数据
            const selectedRowData = event.api.getSelectedRows()
            // 过滤出没有勾选的行数据
            const unselectedRowData = allRowData.filter(rowData => !selectedRowData.includes(rowData))
            if (!unselectedRowData || unselectedRowData.length === 0) {
              return
            }
            for (const data of unselectedRowData) {
              const indexToRemove = this.selectKeys.indexOf(data.uuid)
              if (indexToRemove !== -1) {
                this.selectKeys.splice(indexToRemove, 1)
              }
            }
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.Select'),
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            checkboxSelection: function(params) {
              return params.data.showCheckbox
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerNo'),
            colId: 'containerNo',
            field: 'containerNo',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.ChargeSource'), colId: 'source', field: 'source'
          },
          {
            headerName: this.$t('SeaExport.SealNo'),
            colId: 'sealno',
            field: 'sealno',
            width: 100,
            cellStyle: (params) => {
              return (params.data.differentField && (params.data.differentField['sealno'] || params.data.differentField['sealno'])) ? { color: 'red' } : { color: '' }
            }
          },
          {
            headerName: this.$t('SeaExport.SoNo'),
            colId: 'soNo',
            field: 'soNo',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.ContainerSize') + '/' + this.$t('SeaExport.ContainerType'),
            colId: 'sizeAndType',
            field: 'sizeAndType',
            width: 100,
            cellRenderer: (params) => {
              return params.data.eqSize + '' + params.data.eqType
            },
            cellStyle: (params) => {
              return (params.data.differentField && (params.data.differentField['eqSize'] || params.data.differentField['eqType'])) ? { color: 'red' } : { color: '' }
            }
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantity',
            field: 'quantity',
            width: 100,
            cellStyle: (params) => {
              return (params.data.differentField && params.data.differentField['quantity']) ? { color: 'red' } : { color: '' }
            }
          },
          {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weight',
            field: 'weight',
            width: 100,
            cellStyle: (params) => {
              return (params.data.differentField && params.data.differentField['weight']) ? { color: 'red' } : { color: '' }
            }
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            cellStyle: (params) => {
              return (params.data.differentField && params.data.differentField['cubage']) ? { color: 'red' } : { color: '' }
            }
          }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.handlerCompareData()
        setTimeout(() => {
          // 默认选中全部
          for (const key of Object.keys(this.allMap)) {
            this.selectKeys.push(key)
          }
          this.harbour.gridOptions.api.setFocusedCell(0, this.harbour.gridOptions.api.columnController.getAllDisplayedColumns()[0])
          const node = this.harbour.gridOptions.api.rowModel.rowsToDisplay[0]
          this.onRowClicked(node)
        }, 200)
      }
    },
    job(newVal, oldVal) {
      if (newVal) {
        this.loadPoItems()
      }
    }
  },
  methods: {
    async loadPoItems() {
      this.containerUsages = this.job.containerUsages
      this.dataSource.forEach(element => {
        element.form = 'S'
        element.weight = element.grossWeight
        delete element.grossWeight
      })
      this.poItems = lodash.cloneDeep(this.dataSource)
    },
    // 对数据按需求进行对比
    handlerCompareData() {
      // 表格初始化
      this.$nextTick(() => {
        this.harbour.gridOptions.api.clearFocusedCell() // 刷新
        this.detail.gridOptions.api.clearFocusedCell() // 刷新
        this.harbour.gridOptions.api.deselectAll() // 刷新
        this.detail.gridOptions.api.deselectAll() // 刷新
        this.detail.gridOptions.api.forEachNode((node) => {
          node.setSelected(false)
        }) // 刷新
        this.detail.rowData = []
      })
      this.tableList = []
      this.selectKeys = []
      this.localHbrBourKeys = {}
      this.harbourSource.map(e => {
        e.form = 'G'
        const isSystemVerificationHasNotConfirm = e.confirmed === 10 && PortDataCompareUtils.systemVerificationHasNotConfirm(e.containerNo, this.harbourSource)
        if ((e.confirmed === 0 || isSystemVerificationHasNotConfirm) && !e.type) {
          this.localHbrBourKeys[e.uuid] = true
        }
      })
      let backgroundColor = true
      const usagesMap = {}
      const allMap = {}
      this.containerUsages = this.containerUsages.sort((a, b) => {
        // 检查 a 的箱号是否为空
        if (!a.containerNo) return 1 // 如果 a 箱号为空，将其排在后面

        // 检查 b 的箱号是否为空
        if (!b.containerNo) return -1 // 如果 b 箱号为空，将其排在后面
        // 先按箱号排序
        if (a.containerNo < b.containerNo) return -1
        if (a.containerNo > b.containerNo) return 1
        // 再根据箱型排序
        return b.eqType.localeCompare(a.eqType)
      })

      const harbours = this.harbourSource.filter(item => [0, 10].indexOf(item.confirmed) > -1) || []
      // 将海勃数据进行箱号汇总
      const harbourSourceMap = harbours.reduce((acc, currentItem) => {
        const { containerNo } = currentItem
        if (!acc.has(containerNo)) {
          acc.set(containerNo, [])
        }
        acc.get(containerNo).push(currentItem)
        return acc
      }, new Map())

      // 匹配流程，先按箱号匹配，匹配上的数据放在harbourMatchList中，未匹配到的数据放到harbourNotMatchList里

      const tempUsage = {}
      this.containerUsages.forEach((containerUsage, keys) => {
        delete containerUsage.type
        containerUsage.differentField = {}
        harbourSourceMap.forEach((value, key) => {
          const harborDistrictData = value[0]
          const compareYet = usagesMap.hasOwnProperty(harborDistrictData.containerNo)
          const hasExists = tempUsage.hasOwnProperty(containerUsage.uuid)
          // 存在且一致
          const isSame = hasExists && (tempUsage[containerUsage.uuid] === harborDistrictData.containerNo)
          // 箱号不为空，且箱号相同的数据，或当前业务的箱号为空，港区的箱号不为空且箱型箱量相同的
          if ((!StrUtils.isEmpty(harborDistrictData.containerNo) && (harborDistrictData.containerNo === containerUsage.containerNo)) ||
            (StrUtils.isEmpty(containerUsage.containerNo) && harborDistrictData.containerNo && (!hasExists || isSame) && containerUsage.eqSize === harborDistrictData.eqSize && (harborDistrictData.eqType === containerUsage.eqType || harborDistrictData.eqType.indexOf(containerUsage.eqType) > -1))) {
            const isSystemVerificationHasNotConfirm = harborDistrictData.confirmed === 10 && PortDataCompareUtils.systemVerificationHasNotConfirm(harborDistrictData.containerNo, this.harbourSource)
            if (!compareYet && ((harborDistrictData.confirmed === 0) || isSystemVerificationHasNotConfirm) && !harborDistrictData.type) {
              tempUsage[containerUsage.uuid] = harborDistrictData.containerNo
              backgroundColor = !backgroundColor
              harborDistrictData.eqType = harborDistrictData.eqType instanceof Array ? (harborDistrictData.eqType.indexOf(containerUsage.eqType) > -1 ? containerUsage.eqType : harborDistrictData.eqType[0]) : harborDistrictData.eqType
              this.addMatchNode(containerUsage, value, usagesMap, allMap)
            }
          }
        })
      })
      this.handlerNotMatchData(harbourSourceMap, usagesMap, allMap)
      // 组装数据
      const list = []
      for (const key of Object.keys(usagesMap)) {
        list.push({ containerNo: key })
      }
      this.usageMap = usagesMap
      this.harbour.rowData = list
      this.allMap = allMap
    },
    handlerNotMatchData(harbourSourceMap, usagesMap, allMap) {
      // 处理不匹配的数据
      // 无箱号的系统数据
      const notMatchUsageNoContainerNos = this.containerUsages.filter(element => !element.type && !element.containerNo)
      const notMatchHarbourMap = new Map()
      let notMatchHarbourNum = 0
      harbourSourceMap.forEach((value, key) => {
        if (!usagesMap.hasOwnProperty(key)) {
          notMatchHarbourNum++
          notMatchHarbourMap.set(key, value)
        }
      })
      const notMatchUsageNum = !notMatchUsageNoContainerNos ? 0 : notMatchUsageNoContainerNos.length

      // 不匹配的数量相等,采用覆盖逻辑, 按顺序配对
      if (notMatchUsageNum > 0 && notMatchHarbourNum > 0) {
        let index = 0
        for (const entry of notMatchHarbourMap.entries()) {
          const [key, value] = entry
          if (notMatchUsageNum < index + 1) {
            return this.handlerNotMatchData(harbourSourceMap, usagesMap, allMap)
          }
          const usage = notMatchUsageNoContainerNos[index]
          index++
          this.addMatchNode(usage, value, usagesMap, allMap)
        }
        return this.handlerNotMatchData(harbourSourceMap, usagesMap, allMap)
      }
      let others = []
      // 港区没有，系统还有，则将系统放入其他
      if (notMatchUsageNum > 0 && notMatchHarbourNum === 0) {
        for (const notMatchUsage of notMatchUsageNoContainerNos) {
          const usage = this.addSystemData(notMatchUsage)
          others.push(usage)
          if (usage.children && usage.children.length > 1) {
            others = others.concat(usage.children)
          }
          allMap[usage.uuid] = usage
        }
      }

      // 有箱号的系统数据
      const notMatchUsageHasContainerNos = this.containerUsages.filter(element => !element.type && element.containerNo)
      // 不匹配的数量不等, 放入其他
      for (const notMatchUsage of notMatchUsageHasContainerNos) {
        const usage = this.addSystemData(notMatchUsage)
        others.push(usage)
        if (usage.children && usage.children.length > 1) {
          others = others.concat(usage.children)
        }
        allMap[usage.uuid] = usage
      }
      notMatchHarbourMap.forEach((value, key) => {
        const harbour = this.addHarbourData(value, '', true)
        others = others.concat(harbour)
        allMap[harbour[0].uuid] = harbour[0]
      })
      if (others && others.length > 0) {
        usagesMap['其他'] = others
      }
    },
    // 设置表格是否可以勾选
    selectable(row, index) {
      if ((row.children || row.type === '保存') && !row.isSystemData) {
        return true
      } else {
        return false
      }
    },
    calculation(source, target, data) {
      target.quantity += data.quantity ? parseInt(data.quantity) : 0
      target.weight += data.weight ? parseFloat(data.weight) : 0
      target.cubage += data.cubage ? parseFloat(data.cubage) : 0
      if (source) {
        source.quantity = target.quantity
        source.weight = target.weight
        source.cubage = target.cubage
      }
    },
    addMatchNode(systemData, harbourData, usagesMap, allMap) {
      const systemObj = this.addSystemData(systemData)
      const harbourDatas = this.addHarbourData(harbourData, systemData.uuid)
      const harbour = harbourDatas[0]
      const fields = ['sealno', 'eqSize', 'eqType', 'quantity', 'weight', 'cubage']
      this.checkData(systemObj, harbour, fields)
      // 不一样的字段进行处理
      systemObj.harbours = harbourDatas
      let result = []
      result.push(systemObj)
      if (systemObj.children && systemObj.children.length > 1) {
        result = result.concat(systemObj.children)
      }
      result = result.concat(harbourDatas)
      usagesMap[harbour.containerNo] = result
      allMap[systemData.uuid] = systemObj
    },
    checkData(systemObj, harbour, fields) {
      const differentField = {}
      for (const field of fields) {
        if (systemObj[field] !== harbour[field]) {
          differentField[field] = true
        }
      }
      systemObj.differentField = differentField
      harbour.differentField = differentField
    },
    addSystemData(data) {
      data['type'] = '修改'
      let quantity = 0
      let weight = 0.000
      let cubage = 0.000
      const sealNo = data.hasOwnProperty('sealno') ? data.sealno : data.sealNo
      if (data.poItems && data.poItems.length > 0) {
        data.poItems.forEach(item => {
          item.weight = item.grossWeight
          item.sealno = sealNo
          item.source = '系统数据'
          quantity += item.quantity ? parseInt(item.quantity) : 0
          weight += item.weight ? parseFloat(item.weight) : 0
          cubage += item.cubage ? parseFloat(item.cubage) : 0
        })
      } else {
        quantity = data.quantity
        weight = data.weight
        cubage = data.cubage
      }
      const obj = {
        uuid: data.uuid,
        source: data.poItems && data.poItems.length > 1 ? '系统数据-合计' : '系统数据',
        containerNo: data.containerNo,
        sealno: sealNo,
        sealNo: sealNo,
        soNo: data.poItems && data.poItems.length === 1 ? data.poItems[0].soNo : '',
        eqSize: data.eqSize,
        eqType: data.eqType,
        quantity: NumberUtils.formatNumber(quantity, 0),
        weight: NumberUtils.formatNumber(weight, 3),
        cubage: NumberUtils.formatNumber(cubage, 3),
        children: data.poItems ? deepClone(data.poItems) : [],
        container: data.container,
        showCheckbox: true
      }
      PortDataCompareUtils.syncPortDate(data, obj)
      data.tempPoItems = []
      data.tempPoItems = data.tempPoItems.concat(data.poItems)
      obj.differentField = {}
      return obj
    },
    addHarbourData(harbourDataList, sourceUuid, showCheckbox = false) {
      // 判断条数，如果是一条，则不用拆分合并
      const results = []
      const data = harbourDataList[0]
      const obj = this.addHarbourObj(data, sourceUuid)
      obj.showCheckbox = showCheckbox
      obj.keys = []
      obj.poItems = []
      const newUsages = {}
      data.jobUuid = this.job.uuid
      if (harbourDataList.length === 1) {
        PortDataCompareUtils.addNewContainerUsages(data, newUsages)
        obj.source = '港区数据'
        const item = deepClone(obj)
        item.uuid = ''
        item.grossWeight = item.weight
        obj.poItems.push(item)
        obj.keys.push(data.uuid)
        if (sourceUuid === '') {
          obj.newUsages = newUsages[data.containerNo]
        }
        obj.quantity = NumberUtils.formatNumber(obj.quantity || 0, 0)
        obj.weight = NumberUtils.formatNumber(obj.weight || 0, 3)
        obj.cubage = NumberUtils.formatNumber(obj.cubage || 0, 3)
        results.push(obj)
        return results
      }
      obj.source = '港区数据-合计'
      let quantity = 0
      let weight = 0
      let cubage = 0
      results.push(obj)
      for (let i = 0; i < harbourDataList.length; i++) {
        const data = harbourDataList[i]
        // 合计的件毛体要累加
        quantity += data.quantity ? parseInt(data.quantity) : 0
        weight += data.weight ? parseFloat(data.weight) : 0
        cubage += data.cubage ? parseFloat(data.cubage) : 0
        data.jobUuid = this.job.uuid
        PortDataCompareUtils.addNewContainerUsages(data, newUsages)
        const item = this.addHarbourObj(data, sourceUuid)

        item.quantity = NumberUtils.formatNumber(item.quantity || 0, 0)
        item.weight = NumberUtils.formatNumber(item.weight || 0, 3)
        item.cubage = NumberUtils.formatNumber(item.cubage || 0, 3)
        item.source = '港区数据'
        item.uuid = ''
        item.grossWeight = item.weight
        obj.poItems.push(item)
        obj.keys.push(data.uuid)
        results.push(item)
      }
      obj.quantity = NumberUtils.formatNumber(quantity || 0, 0)
      obj.weight = NumberUtils.formatNumber(weight || 0, 3)
      obj.cubage = NumberUtils.formatNumber(cubage || 0, 3)
      if (sourceUuid === '') {
        obj.newUsages = newUsages[data.containerNo]
      }
      return results
    },
    addHarbourObj(data, sourceUuid) {
      data.eqType = data.eqType instanceof Array ? data.eqType[0] : data.eqType
      const obj = {
        uuid: data.uuid,
        sourceUuid: sourceUuid,
        containerNo: data.containerNo,
        sealno: data.sealno,
        sealNo: data.sealno,
        soNo: data.soNo,
        eqSize: data.eqSize,
        eqType: data.eqType,
        quantity: data.quantity,
        weight: data.weight,
        cubage: data.cubage
      }
      PortDataCompareUtils.syncPortDate(data, obj)
      return obj
    },
    // 取消变更
    cancel() {
      // 表格初始化
      this.$nextTick(() => {
        this.harbour.gridOptions.api.clearFocusedCell() // 刷新
        this.detail.gridOptions.api.clearFocusedCell() // 刷新
        this.harbour.gridOptions.api.deselectAll() // 刷新
        this.detail.gridOptions.api.deselectAll() // 刷新
        this.detail.gridOptions.api.forEachNode((node) => {
          node.setSelected(false)
        }) // 刷新
        this.detail.rowData = []
      })
      if (this.harbourSource && this.harbourSource.length > 0) {
        this.harbourSource.forEach((eve, index) => {
          eve.eqType = PortDataCompareUtils.transformEqType(eve.eqType, eve.containerHeightCn, this.HQHCFlag)
          if (this.localHbrBourKeys[eve.uuid]) {
            delete eve.type
            delete eve.form
            eve.confirmed = 0
          }
        })
      }
      this.clearDialog()
    },
    // 弹窗关闭
    clearDialog() {
      this.tableList = []
      this.localHbrBourKeys = {}
      this.$emit('update:visible', false)
    },
    // 更新港区数据状态
    submitHarbour() {
      // 如果没有选中的，则不处理数据
      if (!this.selectKeys || this.selectKeys.length === 0) {
        this.cancel()
        return
      }
      this.delUsageKeys = []
      const delPoItemKeys = []
      let harbourSelected = []
      // 处理选中的数据, 遍历及组装数据
      for (const key in this.allMap) {
        const data = this.allMap[key]
        if (this.selectKeys.indexOf(key) > -1) {
          // 如果包含harbour元素，则代表是港区数据覆盖录入数据
          if (data.hasOwnProperty('harbours')) {
            const harbours = data.harbours
            const harbour = harbours[0]
            harbourSelected = harbourSelected.concat(harbour.keys)
            this.containerUsages.forEach(item => {
              if (item.uuid === key) {
                item.isDirty = true
                item.quantity = harbour.quantity
                item.weight = harbour.weight
                item.cubage = harbour.cubage
                item.containerNo = harbour.containerNo
                // 删除原货物明细
                for (const poItem of item.poItems) {
                  delPoItemKeys.push(poItem.uuid)
                }
                item.poItems = harbour.poItems
                item.sealNo = harbour.sealno
                item.confirmed = 11
                // 更新箱型箱种
                if (item.eqSize !== harbour.eqSize || item.eqType !== harbour.eqType) {
                  PortDataCompareUtils.changeSeaEQ(this.job.seaEQ, item.eqSize, item.eqType, harbour.eqSize, harbour.eqType, this.job)
                  item.eqSize = harbour.eqSize
                  item.eqType = harbour.eqType
                }
                PortDataCompareUtils.syncPortDate(harbour, item)
                item.container.isDirty = true
                item.container.sealNo = item.sealNo
                PortDataCompareUtils.syncPortDate(harbour, item.container)
              }
            })
          }
          // 如果只是系统录入，则保持不变，
          if (data.source === '系统数据') {
            continue
          }
          // 如果是港区数据，则新增该数据
          if (data.source.indexOf('港区数据') > -1) {
            harbourSelected = harbourSelected.concat(data.keys)
            const newUsages = data.newUsages
            this.containerUsages.push(newUsages)
          }
          continue
        }
        // 如果是包含harbour元素，则代表录入数据不处理，保留
        if (data.hasOwnProperty('harbours')) {
          continue
        }
        // 如果是未选中数据，如果是系统录入，则删除该数据，
        if (data.source === '系统数据') {
          this.delUsageKeys.push(data.container.uuid)
        }
        // 如果是港区数据，则不处理该数据
        if (data.source.indexOf('港区数据') > -1) {
          continue
        }
      }
      this.cancel()
      const selection = []
      for (const key of harbourSelected) {
        selection.push({
          uuid: key,
          confirmed: 11,
          jobUuid: this.job.uuid
        })
      }
      this.$emit('addContainer', this.delUsageKeys, delPoItemKeys, selection, harbourSelected)
    },
    mappingEqType(scopeRow) {
      if (this.HQHCFlag) {
        return scopeRow.eqType
      }
      if (!scopeRow.isSystemData) {
        if (this.containerHeightFlag) {
          return scopeRow.eqType
        }
        const reflectEqType = scopeRow.eqType
        if (!this.hqFlag || !this.hcFlag) {
          if (this.hqFlag) {
            return reflectEqType.replace('HC', 'HQ')
          }
          return reflectEqType.replace('HQ', 'HC')
        }
      }
      return scopeRow.eqType
    },
    onRowClicked(event) {
      const data = event.data
      this.selectionContainerNo = data.containerNo
      // 选中回选
      this.detail.rowData = this.usageMap[data.containerNo]
      // 处理选中回选
      if (!this.selectKeys || this.selectKeys.length === 0) {
        return
      }
      this.$nextTick(() => {
        this.detail.gridOptions.api.forEachNode(node => {
          if (this.selectKeys.indexOf(node.data.uuid) > -1) {
            node.setSelected(true)
          }
        })
      })
    },
    arrayLength(list) {
      if (!list || list.length === 0) {
        return 0
      }
      return list.length
    }
  }
}
</script>

<style lang="scss" scoped>
.harbour-data-compare{
  .gray{
    color: #cccccc;
  }
  .blue{
    color: blue;
  }
  .none{
    color: #000;
  }
  .harbour-compare-tit{
    margin: 3px 0 8px;
    color: #999;
    font-size: 13px;
    font{
      font-size: 13px;
    }
    p{
      line-height: 26px;
      margin: 0;
      text-indent: 35px;
      font-size: 13px;
    }
  }
  /deep/ .el-table .warning-row {
    background-color: lightgrey;
  }
  /deep/ .el-table .cell-display .el-checkbox__input {
    display: none;
  }

  /deep/ .el-table .success-row {
    background: #ffffff;
  }
  /deep/ .el-table__header-wrapper th{
    color: #000;
  }
}
</style>
